import { PROCESS } from "../data/site";
import { useReveal } from "../hooks/useReveal";
import FlyWords from "./FlyWords";

export default function Process() {
  const ref = useReveal();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="section bg-[#0a0a0a] relative"
      ref={ref}
    >
      <div className="container-x">
        <div className="max-w-3xl mb-14 reveal">
          <div className="overline mb-5">How we work</div>
          <FlyWords
            as="h2"
            className="font-display text-4xl md:text-5xl lg:text-6xl text-white font-light leading-tight"
            segments={[
              { text: "A clear path" },
              { type: "break" },
              { text: "from sketch to reveal.", className: "italic text-[#D4AF37]" },
            ]}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {PROCESS.map((p, i) => (
            <div
              key={p.n}
              data-testid={`process-step-${p.n}`}
              className="surface p-7 md:p-8 reveal"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="step-num">{p.n}</div>
              <h3 className="font-display text-2xl text-white mt-4 mb-2">
                {p.title}
              </h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
